const toFixed2 = value => {
  if (!isFinite(value) || isNaN(value)) {
    return 100;
  }
  return parseFloat(value.toFixed(2));
};

export default toFixed2;
